import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import ThankYou from '../ThankYou';

import logo from '../../assets/images/global/seakeeper-logo-only.svg';

class SizingFormApproved extends Component {

	render() {

		var title = <span>Thank you for approving a Seakeeper <br />Sizing Form & Gyro Configuration!</span>,
			message = <span>We’ll notify you with any updates or when the <br />Sales Person has published the report. <br /><br />You can check its status on your <a href="/dashboard">Dashboard</a>.</span>;

		return (
			<Page pageClass="pp-sizing-form-thank-you-page">
				<ThankYou
					icon={logo}
				 	title={title}
					message={message}
				/>
			</Page>
		);
	}
}

export default SizingFormApproved;



// WEBPACK FOOTER //
// ./src/components/pages/SizingFormApproved.js